import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
// import Header from '../components/header'
import ProductsGrid from "../components/productsGrid"

const IndexPage = () => (
  <StaticQuery
    query={LISTING_QUERY}
    render={data => (
      <>
        {/* <Header
          siteTitle="Sayonara Sale"
          backgroundColor="rgba(255, 255, 255, 0)"
          color="rgba(0, 0, 0, 0.87)"
          location={{ pathname: '/' }}
        /> */}
        <Layout location="/">
          <ProductsGrid products={data.allAirtable} />
        </Layout>
      </>
    )}
  />
)

const LISTING_QUERY = graphql`
  query AllProducts {
    allAirtable {
      edges {
        node {
          id
          data {
            slug
            images {
              url
            }
            price
            description
            product
            category
          }
        }
      }
    }
  }
`

export default IndexPage
